<template>
  <span :class="['rd-status-badge', `rd-status-badge--${tone}`]"><slot /></span>
</template>

<script>
/**
 * @component StatusBadge
 * @description 상태 배지 공통 부품 (SURINP-683). 색은 톤 클래스 하나로만 정한다.
 * 스타일은 전역 tables.css `.rd-status-badge` — AG Grid HTML 문자열 렌더러도 같은 클래스를 쓴다.
 * 1280 미만은 진한 바탕 + 흰 글자, 1280 이상은 연한 바탕 + 진한 글자.
 * 상태 → 톤은 src/constants/statusTone.js.
 */
export default {
  name: 'StatusBadge',
  props: {
    /**
     * 색 톤 — receipt / assign / visit / complete / danger / neutral
     * @type {string}
     */
    tone: {
      type: String,
      default: 'neutral'
    }
  }
}
</script>
